import React from "react";
import './App.css';
import UserFeedbackView from "./component/UserFeedbackView"

export default function App() {
  return (
     <UserFeedbackView />
  );
}
